import { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";
import { track } from "./api";

export const getThemePref = () => {
  try {
    const t = localStorage.getItem("xp_theme");
    if (t === "light" || t === "dark") return t;
    return window.matchMedia("(prefers-color-scheme: light)").matches ? "light" : "dark";
  } catch {
    return "dark";
  }
};

export const setThemePref = (t) => {
  try { localStorage.setItem("xp_theme", t); } catch { /* private mode */ }
  window.dispatchEvent(new Event("xp-theme-changed"));
};

export const useThemePref = () => {
  const [pref, setPref] = useState(getThemePref);
  useEffect(() => {
    const f = () => setPref(getThemePref());
    window.addEventListener("xp-theme-changed", f);
    return () => window.removeEventListener("xp-theme-changed", f);
  }, []);
  return pref;
};

export const ThemeToggle = ({ testId = "theme-toggle" }) => {
  const pref = useThemePref();
  const next = pref === "light" ? "dark" : "light";
  return (
    <button
      data-testid={testId}
      onClick={() => { setThemePref(next); track("theme_toggled", { theme: next }); }}
      aria-label={next === "light" ? "Switch to light theme" : "Switch to dark theme"}
      title={next === "light" ? "Light theme" : "Dark theme"}
      className="xp-iconbtn"
    >
      {pref === "light" ? <Moon size={17} /> : <Sun size={17} />}
    </button>
  );
};
